// extracted by mini-css-extract-plugin
module.exports = {"customHero":"HomeHero_customHero_1Kt00","heroImg":"HomeHero_heroImg_oy768"};